export enum HistoryListType {
  Buy = 'buy',
  Use = 'use',
}
